import type { PokerHand } from './PokerHand';

export const pokerHandsByStrength: PokerHand[] = [
  'HighCard',
  'OnePair',
  'TwoPair',
  'ThreeOfAKind',
  'Straight',
  'Flush',
  'FullHouse',
  'FourOfAKind',
  'StraightFlush',
];
